var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3-3h26v26H-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#827c78",
    fillRule: "nonzero",
    d: "M15.425 13.068l-.205.36 3.36 3.4c.479.486.477 1.268-.006 1.75a1.226 1.226 0 0 1-1.739-.005l-3.36-3.401-.359.256c-1.367.855-2.786 1.283-4.257 1.283-2.154 0-3.992-.77-5.514-2.309-1.522-1.54-2.282-3.386-2.282-5.541 0-2.155.76-3.993 2.282-5.515 1.522-1.522 3.36-2.283 5.514-2.283 2.154 0 3.992.76 5.514 2.283 1.522 1.522 2.283 3.36 2.283 5.515 0 1.505-.41 2.907-1.231 4.207zM13.219 4.5c-1.197-1.197-2.65-1.796-4.36-1.796-1.71 0-3.163.599-4.36 1.796-1.197 1.197-1.795 2.65-1.795 4.361 0 1.71.598 3.164 1.795 4.361 1.197 1.197 2.65 1.796 4.36 1.796 1.71 0 3.163-.599 4.36-1.796 1.231-1.231 1.847-2.685 1.847-4.361 0-1.676-.616-3.13-1.847-4.361z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d06c5116d2bc7812b570637b10d1e8cd.svg";
export { ForwardRef as ReactComponent };